import Styled from 'styled-components';

const ProgressTrackerWrapper = Styled.div`
  display: flex;
  align-items: center;

  & :nth-child(n+2):not(span) {
    margin-left: ${({theme: { progressTracker }}) => progressTracker.hrVerticalOffset};
  }
`;

export default ProgressTrackerWrapper;
